export default (registerData) => {
  const hoy = new Date();
  const cumpleanos = new Date(registerData.EdadProfile);
  let edad = hoy.getFullYear() - cumpleanos.getFullYear();
  const m = hoy.getMonth() - cumpleanos.getMonth();

  if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
    edad--;
  }

  let grupoEdad = '';

  if (edad >= 65) {
    grupoEdad = 'Grupo 9';
  } else if (edad < 65 && edad >= 55) {
    grupoEdad = 'Grupo 8';
  } else if (edad < 55 && edad >= 45) {
    grupoEdad = 'Grupo 7';
  } else if (edad < 45 && edad >= 35) {
    grupoEdad = 'Grupo 6';
  } else if (edad < 35 && edad >= 25) {
    grupoEdad = 'Grupo 5';
  } else if (edad < 25 && edad >= 19) {
    grupoEdad = 'Grupo 4';
  } else if (edad < 19 && edad >= 12) {
    grupoEdad = 'Grupo 3';
  } else if (edad < 12 && edad >= 3) {
    grupoEdad = 'Grupo 2';
  } else if (edad < 3 && edad >= 0) {
    grupoEdad = 'Grupo 1';
  }

  return {
    clubPremierID: registerData.clubPremierID, // Dynamic Data
    country: registerData.country, // Dynamic Data
    EdadProfile: edad, // Dynamic Data
    event: 'registerCP',
    Flujo: 'MYB',
    GrupoEdad: grupoEdad, // Dynamic Data
    position: 'Modal',
    profGender: registerData.profGender, // Dynamic Data
    storefront: registerData.storefront, // Dynamic Data
    touchPoint: registerData.touchPoint, // Dynamic Data
    yearProfile: registerData.yearProfile, // Dynamic Data
  };
};